// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_zC9","cls2":"SimplePaperPodcast-cls2_ehj SimplePaperPodcast-cls1_zC9"};